(function (root, factory) {
  var api = factory(root.ShopThemeUtils || {});

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  root.ShopThemeDom = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function (themeUtils) {
  var formatMoney = themeUtils.formatMoney || function (cents) {
    var n = Number(cents || 0) / 100;
    return '$' + n.toFixed(2);
  };
  var escapeHtml = themeUtils.escapeHtml || function (value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };
  var buildQuoteCartLines = themeUtils.buildQuoteCartLines || function (cart) {
    if (!cart || !cart.items || !cart.items.length) return ['- No cart items detected'];

    return cart.items.map(function (item) {
      var line = '- ' + String(item.product_title || item.title || 'Item');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        line += ' [' + String(item.variant_title) + ']';
      }
      line += ' (Qty: ' + String(item.quantity || 1) + ')';
      return line;
    });
  };
  var extractQuoteAdditionalDetails = themeUtils.extractQuoteAdditionalDetails || function (value, label) {
    var text = String(value || '');
    var markerLabel = String(label || 'Additional details:');
    var marker = '\n\n' + markerLabel + '\n';
    var markerIndex = text.indexOf(marker);
    if (markerIndex !== -1) {
      return text.slice(markerIndex + marker.length).trim();
    }
    if (text.indexOf(markerLabel + '\n') === 0) {
      return text.slice((markerLabel + '\n').length).trim();
    }
    return text.trim();
  };

  function buildQuotePreview(cart, existingValue, additionalDetailsLabel) {
    var details = extractQuoteAdditionalDetails(existingValue, additionalDetailsLabel);
    var preview = [
      'Cart items:',
      buildQuoteCartLines(cart).join('\n'),
      '',
      String(additionalDetailsLabel || 'Additional details:')
    ];

    if (details) preview.push(details);

    return preview.join('\n');
  }

  function getQuotePreviewValue(form, cart, additionalDetailsLabel) {
    if (!form) return '';
    var messageInput = form.querySelector('[data-quote-message]');
    if (!messageInput) return buildQuotePreview(cart, '', additionalDetailsLabel);
    return buildQuotePreview(cart, messageInput.value, additionalDetailsLabel);
  }

  function buildQuoteMessage(form, cart, additionalDetailsLabel) {
    if (!form) return '';

    var companyInput = form.querySelector('[data-quote-company]');
    var nameInput = form.querySelector('[data-quote-name]');
    var emailInput = form.querySelector('[data-quote-email]');
    var lines = [
      'Quote Request',
      '',
      'Company: ' + String(companyInput && companyInput.value ? companyInput.value.trim() : ''),
      'Name: ' + String(nameInput && nameInput.value ? nameInput.value.trim() : ''),
      'Email: ' + String(emailInput && emailInput.value ? emailInput.value.trim() : ''),
      '',
      String(getQuotePreviewValue(form, cart, additionalDetailsLabel) || '')
    ];

    return lines.join('\n');
  }

  function syncQuoteFormFields(quoteModal, cart, additionalDetailsLabel) {
    if (!quoteModal) return;
    var form = quoteModal.querySelector('#sp-quote-form');
    if (!form) return;

    var nameInput = form.querySelector('[data-quote-name]');
    var hiddenNameInput = form.querySelector('[data-quote-name-hidden]');
    var emailInput = form.querySelector('[data-quote-email]');
    var hiddenEmailInput = form.querySelector('[data-quote-email-hidden]');
    var hiddenBodyInput = form.querySelector('[data-quote-body]');
    var messageInput = form.querySelector('[data-quote-message]');

    if (hiddenNameInput) {
      hiddenNameInput.value = nameInput && nameInput.value ? nameInput.value.trim() : '';
    }

    if (hiddenEmailInput) {
      hiddenEmailInput.value = emailInput && emailInput.value ? emailInput.value.trim() : '';
    }

    if (messageInput) {
      messageInput.value = getQuotePreviewValue(form, cart, additionalDetailsLabel);
    }

    if (hiddenBodyInput) {
      hiddenBodyInput.value = buildQuoteMessage(form, cart, additionalDetailsLabel);
    }
  }

  function updateCartCount(itemCount, root) {
    (root || document).querySelectorAll('.sp-cart-link span').forEach(function (node) {
      node.textContent = '(' + String(itemCount || 0) + ')';
    });
  }

  function renderCartDrawer(cart, elements) {
    var cartDrawerItems = elements && elements.cartDrawerItems;
    var cartDrawerSubtotal = elements && elements.cartDrawerSubtotal;
    var root = elements && elements.root;
    if (!cartDrawerItems) return;

    updateCartCount(cart.item_count, root);

    if (!cart.items || !cart.items.length) {
      cartDrawerItems.innerHTML = '<div class="sp-cart-drawer__empty"><p>Your cart is empty.</p></div>';
      if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
      return;
    }

    cartDrawerItems.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '">' : '<div class="sp-cart-drawer__thumb-placeholder"></div>';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? '<p>' + escapeHtml(item.variant_title) + '</p>' : '';
      return ''
        + '<article class="sp-cart-drawer__item">'
        + '  <a href="' + escapeHtml(item.url || '/cart') + '" class="sp-cart-drawer__thumb">' + image + '</a>'
        + '  <div class="sp-cart-drawer__meta">'
        + '    <h3><a href="' + escapeHtml(item.url || '/cart') + '">' + escapeHtml(item.product_title || item.title || 'Item') + '</a></h3>'
        +      variantTitle
        + '    <strong>' + formatMoney(item.final_price) + '</strong>'
        + '    <div class="sp-cart-drawer__qty">'
        + '      <button type="button" data-cart-line-change data-line="' + String(index + 1) + '" data-quantity="' + String(Math.max(0, item.quantity - 1)) + '">-</button>'
        + '      <span>' + String(item.quantity) + '</span>'
        + '      <button type="button" data-cart-line-change data-line="' + String(index + 1) + '" data-quantity="' + String(item.quantity + 1) + '">+</button>'
        + '      <button type="button" class="sp-cart-drawer__remove" data-cart-line-change data-line="' + String(index + 1) + '" data-quantity="0">Remove</button>'
        + '    </div>'
        + '  </div>'
        + '</article>';
    }).join('');

    if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
  }

  function applyCardVariantSelection(card, button) {
    if (!card || !button) return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    card.querySelectorAll('[data-card-variant-option]').forEach(function (optionButton) {
      var isActive = optionButton === button;
      optionButton.classList.toggle('is-active', isActive);
      optionButton.setAttribute('aria-pressed', String(isActive));
    });

    var variantInput = card.querySelector('.sp-card__form input[name="id"]');
    if (variantInput) variantInput.value = variantId;

    var price = button.getAttribute('data-variant-price');
    var compare = button.getAttribute('data-variant-compare');
    var priceEl = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare]');

    if (priceEl) priceEl.textContent = formatMoney(price);
    if (compareEl) {
      if (Number(compare || 0) > Number(price || 0)) {
        compareEl.textContent = formatMoney(compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var mediaEl = card.querySelector('[data-card-media]');
    var imageUrl = button.getAttribute('data-variant-image');
    if (mediaEl && imageUrl) mediaEl.src = imageUrl;

    var isAvailable = button.getAttribute('data-variant-available') === 'true';
    var addButton = card.querySelector('[data-card-add]');
    if (addButton) {
      var defaultLabel = addButton.getAttribute('data-default-label') || 'Add to cart';
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? defaultLabel : 'Sold out';
      addButton.classList.toggle('sp-btn--muted', !isAvailable);
      addButton.classList.toggle('sp-btn--primary', isAvailable);
    }
  }

  return {
    applyCardVariantSelection: applyCardVariantSelection,
    buildQuoteMessage: buildQuoteMessage,
    buildQuotePreview: buildQuotePreview,
    getQuotePreviewValue: getQuotePreviewValue,
    renderCartDrawer: renderCartDrawer,
    syncQuoteFormFields: syncQuoteFormFields,
    updateCartCount: updateCartCount
  };
});
